module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_add-to-unscopables.js
 ** module id = 62
 ** module chunks = 0
 **/